/**
 * OneVet Blog v2 — Filter + Search
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-blog-v2]');
  if (!root) return;

  const searchInput = root.querySelector('[data-bv2-search]');
  const searchClear = root.querySelector('[data-bv2-search-clear]');
  const chips = root.querySelectorAll('[data-bv2-filter]');
  const cards = root.querySelectorAll('[data-bv2-card]');
  const emptyEl = root.querySelector('[data-bv2-empty]');
  const grid = root.querySelector('[data-bv2-grid]');

  let activeFilter = 'all';
  let activeSearch = '';

  function normalize(s) {
    return (s || '').toString().toLowerCase()
      .replace(/ı/g, 'i').replace(/İ/g, 'i')
      .replace(/ö/g, 'o').replace(/Ö/g, 'o')
      .replace(/ü/g, 'u').replace(/Ü/g, 'u')
      .replace(/ş/g, 's').replace(/Ş/g, 's')
      .replace(/ç/g, 'c').replace(/Ç/g, 'c')
      .replace(/ğ/g, 'g').replace(/Ğ/g, 'g')
      .trim();
  }

  function applyFilters() {
    const q = normalize(activeSearch);
    const tagFilter = activeFilter;
    let visibleCount = 0;

    cards.forEach((card) => {
      const title = normalize(card.dataset.bv2Title || '');
      const tags = (card.dataset.bv2Tags || '').toLowerCase();
      const tagsNorm = normalize(tags);

      // Tag match
      let tagMatch = true;
      if (tagFilter !== 'all') {
        const chip = root.querySelector(`[data-bv2-filter="${tagFilter}"]`);
        const realTag = chip?.dataset.bv2Tag || tagFilter;
        const realTagNorm = normalize(realTag);
        tagMatch = tagsNorm.includes(realTagNorm);
      }

      // Search match (title or tags)
      let searchMatch = true;
      if (q) {
        searchMatch = title.includes(q) || tagsNorm.includes(q);
      }

      const visible = tagMatch && searchMatch;
      card.classList.toggle('is-hidden', !visible);
      if (visible) visibleCount++;
    });

    // Hero card: only show with no filter + no search
    const hero = root.querySelector('.bv2-hero');
    if (hero) {
      const showHero = tagFilter === 'all' && !q;
      hero.style.display = showHero ? '' : 'none';
    }

    if (emptyEl) emptyEl.hidden = visibleCount > 0;
  }

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      chips.forEach((c) => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      activeFilter = chip.dataset.bv2Filter;
      applyFilters();
      // Scroll grid into view (mobile)
      if (window.innerWidth < 768 && grid) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  if (searchInput) {
    let t;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      activeSearch = searchInput.value;
      if (searchClear) searchClear.hidden = !activeSearch;
      t = setTimeout(applyFilters, 180);
    });
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        searchInput.value = '';
        activeSearch = '';
        if (searchClear) searchClear.hidden = true;
        applyFilters();
      }
    });
  }
  if (searchClear) {
    searchClear.addEventListener('click', () => {
      searchInput.value = '';
      activeSearch = '';
      searchClear.hidden = true;
      searchInput.focus();
      applyFilters();
    });
  }

  // Reset (empty state)
  root.querySelector('[data-bv2-reset]')?.addEventListener('click', () => {
    activeFilter = 'all';
    activeSearch = '';
    if (searchInput) searchInput.value = '';
    if (searchClear) searchClear.hidden = true;
    chips.forEach((c) => c.classList.toggle('is-active', c.dataset.bv2Filter === 'all'));
    applyFilters();
  });

  // URL params support: ?tag=kedi
  try {
    const params = new URLSearchParams(window.location.search);
    const initialTag = params.get('tag') || params.get('filter');
    if (initialTag) {
      const chip = Array.from(chips).find((c) =>
        normalize(c.dataset.bv2Tag || c.dataset.bv2Filter) === normalize(initialTag)
      );
      if (chip) chip.click();
    }
  } catch (_) {}
})();
